var map = {
	"./assets/ICO/Takeout.png": 18003,
	"./assets/ICO/automatic-detail-current-1.png": 89225,
	"./assets/ICO/automatic-detail-current-2.png": 24690,
	"./assets/ICO/automatic-detail-current-3.png": 46235,
	"./assets/ICO/deposit.png": 94666,
	"./assets/apiKey/copy.png": 19185,
	"./assets/apiKey/del.png": 163,
	"./assets/apiKey/lock.png": 70907,
	"./assets/apiKey/nodata.png": 54799,
	"./assets/assetsImg/account_bg.png": 46750,
	"./assets/assetsImg/ascending.png": 13473,
	"./assets/assetsImg/back.png": 11766,
	"./assets/assetsImg/back_logo.png": 18990,
	"./assets/assetsImg/buycoin.png": 62576,
	"./assets/assetsImg/chargenew.png": 41881,
	"./assets/assetsImg/close.png": 86219,
	"./assets/assetsImg/date_logo.png": 23061,
	"./assets/assetsImg/deal.png": 67653,
	"./assets/assetsImg/default.png": 80832,
	"./assets/assetsImg/descending.png": 56137,
	"./assets/assetsImg/dropdown.png": 65904,
	"./assets/assetsImg/enter.png": 60997,
	"./assets/assetsImg/eye_close.png": 97753,
	"./assets/assetsImg/eye_open.png": 56877,
	"./assets/assetsImg/hourglass.png": 84657,
	"./assets/assetsImg/info.png": 45171,
	"./assets/assetsImg/item1_g.png": 82703,
	"./assets/assetsImg/item1_h.png": 15224,
	"./assets/assetsImg/item2_g.png": 28032,
	"./assets/assetsImg/item2_h.png": 94036,
	"./assets/assetsImg/item3_g.png": 61905,
	"./assets/assetsImg/item3_h.png": 23126,
	"./assets/assetsImg/item4_g.png": 35010,
	"./assets/assetsImg/item4_h.png": 35877,
	"./assets/assetsImg/item5_g.png": 84595,
	"./assets/assetsImg/item5_h.png": 58676,
	"./assets/assetsImg/item6_g.png": 9508,
	"./assets/assetsImg/item6_h.png": 9699,
	"./assets/assetsImg/next.png": 50788,
	"./assets/assetsImg/not_select.png": 58561,
	"./assets/assetsImg/open.png": 94863,
	"./assets/assetsImg/qrcode_logo.png": 37015,
	"./assets/assetsImg/recharge.png": 45864,
	"./assets/assetsImg/record.png": 45800,
	"./assets/assetsImg/selected.png": 55836,
	"./assets/assetsImg/sellcoin.png": 36892,
	"./assets/assetsImg/text.png": 97218,
	"./assets/assetsImg/tips.png": 43305,
	"./assets/assetsImg/total_g.png": 20911,
	"./assets/assetsImg/total_y.png": 77649,
	"./assets/assetsImg/transfer-icon.png": 44610,
	"./assets/assetsImg/transfer.png": 98126,
	"./assets/assetsImg/transition.png": 79022,
	"./assets/assetsImg/trunTo_logo.png": 68313,
	"./assets/assetsImg/video.png": 10414,
	"./assets/assetsImg/withdraw.png": 33881,
	"./assets/authenticate/custom.png": 13705,
	"./assets/authenticate/face_logo.png": 20457,
	"./assets/authenticate/fail_logo.png": 87000,
	"./assets/authenticate/idcard.png": 83593,
	"./assets/authenticate/idcard1.png": 48292,
	"./assets/authenticate/loading_logo.png": 62182,
	"./assets/authenticate/not_logo.png": 3299,
	"./assets/authenticate/success_logo.png": 94309,
	"./assets/authenticate/user_info.png": 12050,
	"./assets/buyCoinsImg/77777.mp4": 28899,
	"./assets/buyCoinsImg/ad_action_down.png": 65081,
	"./assets/buyCoinsImg/ad_icon.png": 75737,
	"./assets/buyCoinsImg/ad_icon_selected.png": 52301,
	"./assets/buyCoinsImg/business_bg.jpg": 55432,
	"./assets/buyCoinsImg/business_img.png": 88880,
	"./assets/buyCoinsImg/business_title1.png": 470,
	"./assets/buyCoinsImg/business_title2.png": 91149,
	"./assets/buyCoinsImg/business_title3.png": 64996,
	"./assets/buyCoinsImg/business_vip1.png": 55743,
	"./assets/buyCoinsImg/business_vip2.png": 70468,
	"./assets/buyCoinsImg/business_vip3.png": 33709,
	"./assets/buyCoinsImg/bussiness_icon.png": 3307,
	"./assets/buyCoinsImg/check_step_1.png": 54335,
	"./assets/buyCoinsImg/check_step_2.png": 99684,
	"./assets/buyCoinsImg/checked.png": 73347,
	"./assets/buyCoinsImg/empty_pay.png": 60740,
	"./assets/buyCoinsImg/export_icon.png": 97946,
	"./assets/buyCoinsImg/filter.png": 87056,
	"./assets/buyCoinsImg/head.png": 63084,
	"./assets/buyCoinsImg/headbuy-fast.png": 74915,
	"./assets/buyCoinsImg/headbuy_c2c.png": 16213,
	"./assets/buyCoinsImg/mer_g.png": 41182,
	"./assets/buyCoinsImg/mer_w.png": 22318,
	"./assets/buyCoinsImg/methods_g.png": 40236,
	"./assets/buyCoinsImg/methods_w.png": 89628,
	"./assets/buyCoinsImg/msg_icon.png": 39699,
	"./assets/buyCoinsImg/msg_icon_selected.png": 42143,
	"./assets/buyCoinsImg/new_g.png": 37836,
	"./assets/buyCoinsImg/new_hand_bg2.png": 38100,
	"./assets/buyCoinsImg/new_hand_bg3.png": 54781,
	"./assets/buyCoinsImg/new_hand_icon1.png": 96125,
	"./assets/buyCoinsImg/new_hand_icon2.png": 54886,
	"./assets/buyCoinsImg/new_w.png": 37756,
	"./assets/buyCoinsImg/pay_icon.png": 90856,
	"./assets/buyCoinsImg/pay_method.png": 19744,
	"./assets/buyCoinsImg/pay_to_icon.png": 81758,
	"./assets/buyCoinsImg/report_icon1.png": 45525,
	"./assets/buyCoinsImg/report_icon2.png": 59774,
	"./assets/buyCoinsImg/shop_icon.png": 78676,
	"./assets/buyCoinsImg/shop_icon_selected.png": 59742,
	"./assets/buyCoinsImg/step_1.png": 74196,
	"./assets/buyCoinsImg/step_2.png": 96655,
	"./assets/buyCoinsImg/step_3.png": 11558,
	"./assets/buyCoinsImg/step_icon.png": 82178,
	"./assets/commission/arrow-right.png": 26204,
	"./assets/commission/cut.png": 28494,
	"./assets/commission/cut_white.png": 15444,
	"./assets/commission/edit.png": 76084,
	"./assets/commission/edit_white.png": 11810,
	"./assets/commission/export.png": 84142,
	"./assets/commission/menu.png": 81529,
	"./assets/commission/poster.png": 94419,
	"./assets/commission/reload.png": 7187,
	"./assets/commission/rule_tip.png": 10932,
	"./assets/commission/title_icon_1.png": 16574,
	"./assets/commission/title_icon_2.png": 83925,
	"./assets/commission/title_icon_3.png": 14828,
	"./assets/commission/title_icon_4.png": 44995,
	"./assets/commission/total_icon_1.png": 81098,
	"./assets/commission/total_icon_2.png": 22177,
	"./assets/commission/total_icon_3.png": 1048,
	"./assets/common/IdCardJust.png": 10079,
	"./assets/common/Subtract@2x.png": 71160,
	"./assets/common/arrow_top.png": 34053,
	"./assets/common/bottom_dropdown.png": 53257,
	"./assets/common/cardBg.png": 65675,
	"./assets/common/cardRever.png": 4878,
	"./assets/common/date_logo.png": 9988,
	"./assets/common/discord.png": 80046,
	"./assets/common/discord_y.png": 94402,
	"./assets/common/download.png": 33496,
	"./assets/common/edit@2x.png": 51288,
	"./assets/common/empty_logo.png": 21935,
	"./assets/common/facebook.png": 12680,
	"./assets/common/facebook_y.png": 60824,
	"./assets/common/file.png": 64522,
	"./assets/common/identSucesses.png": 97826,
	"./assets/common/in.png": 10009,
	"./assets/common/in_y.png": 21121,
	"./assets/common/ins.png": 23238,
	"./assets/common/ins_y.png": 21242,
	"./assets/common/language.png": 49466,
	"./assets/common/logo.png": 7229,
	"./assets/common/logo_text-51.png": 19636,
	"./assets/common/logo_text.png": 98731,
	"./assets/common/medium.png": 39169,
	"./assets/common/medium_y.png": 45609,
	"./assets/common/no_result.png": 65561,
	"./assets/common/photo.png": 39410,
	"./assets/common/reddit.png": 3244,
	"./assets/common/reddit_y.png": 97268,
	"./assets/common/right_logo.png": 13840,
	"./assets/common/setting.png": 19258,
	"./assets/common/share.png": 22691,
	"./assets/common/tg.png": 92455,
	"./assets/common/tg_y.png": 22547,
	"./assets/common/twitter.png": 14399,
	"./assets/common/twitter_y.png": 16651,
	"./assets/common/utube.png": 94229,
	"./assets/common/utube_y.png": 5045,
	"./assets/common/vip-back-1.png": 82525,
	"./assets/common/vip-back-2.png": 1318,
	"./assets/common/vip1.png": 29962,
	"./assets/common/vip2.png": 44193,
	"./assets/common/vip3.png": 23064,
	"./assets/common/vip4.png": 72055,
	"./assets/common/vip5.png": 26478,
	"./assets/common/vip6.png": 96837,
	"./assets/common/vip7.png": 13948,
	"./assets/common/vip_back.png": 69229,
	"./assets/common/watermark.png": 40832,
	"./assets/country/东帝汶.png": 77132,
	"./assets/country/东萨摩亚(美).png": 5717,
	"./assets/country/中华人民共和国澳门特别行政区.png": 94263,
	"./assets/country/中华人民共和国香港特别行政区.png": 29616,
	"./assets/country/中国.png": 23623,
	"./assets/country/丹麦.png": 69720,
	"./assets/country/乌克兰.png": 21116,
	"./assets/country/乌兹别克斯坦.png": 41385,
	"./assets/country/乌干达.png": 68881,
	"./assets/country/乌拉圭.png": 6931,
	"./assets/country/乍得.png": 78733,
	"./assets/country/也门.png": 25936,
	"./assets/country/亚美尼亚.png": 69751,
	"./assets/country/以色列.png": 57605,
	"./assets/country/伊拉克.png": 74063,
	"./assets/country/伊朗.png": 26784,
	"./assets/country/伯利兹.png": 17388,
	"./assets/country/佛得角.png": 8705,
	"./assets/country/俄罗斯.png": 69719,
	"./assets/country/保加利亚.png": 45719,
	"./assets/country/关岛.png": 68399,
	"./assets/country/冈比亚.png": 97683,
	"./assets/country/冰岛.png": 33682,
	"./assets/country/几内亚.png": 13964,
	"./assets/country/几内亚比绍.png": 52957,
	"./assets/country/列支敦士登.png": 66023,
	"./assets/country/刚果(金).png": 74009,
	"./assets/country/利比亚.png": 95146,
	"./assets/country/利比里亚.png": 29708,
	"./assets/country/加拿大.png": 12347,
	"./assets/country/加纳.png": 99114,
	"./assets/country/加蓬.png": 61549,
	"./assets/country/匈牙利.png": 55691,
	"./assets/country/南苏丹.png": 97574,
	"./assets/country/博茨瓦纳.png": 75550,
	"./assets/country/卡塔尔.png": 49564,
	"./assets/country/卢旺达.png": 50727,
	"./assets/country/卢森堡.png": 9300,
	"./assets/country/印度.png": 21975,
	"./assets/country/印度尼西亚.png": 86948,
	"./assets/country/危地马拉.png": 83003,
	"./assets/country/厄瓜多尔.png": 39043,
	"./assets/country/厄立特里亚.png": 58963,
	"./assets/country/叙利亚.png": 14005,
	"./assets/country/古巴.png": 72497,
	"./assets/country/台湾省.png": 75382,
	"./assets/country/吉尔吉斯坦.png": 63470,
	"./assets/country/吉布提.png": 76913,
	"./assets/country/哈萨克斯坦.png": 6093,
	"./assets/country/哥伦比亚.png": 77010,
	"./assets/country/哥斯达黎加.png": 31005,
	"./assets/country/喀麦隆.png": 20577,
	"./assets/country/图瓦卢.png": 58803,
	"./assets/country/土库曼斯坦.png": 25911,
	"./assets/country/土耳其.png": 10461,
	"./assets/country/圣卢西亚.png": 32409,
	"./assets/country/圣多美和普林西比.png": 66416,
	"./assets/country/圣文森特岛.png": 14513,
	"./assets/country/圭亚那.png": 53729,
	"./assets/country/坦桑尼亚.png": 52452,
	"./assets/country/埃及.png": 32038,
	"./assets/country/埃塞俄比亚.png": 56450,
	"./assets/country/塔吉克斯坦.png": 44074,
	"./assets/country/塞内加尔.png": 62514,
	"./assets/country/塞拉利昂.png": 21055,
	"./assets/country/塞浦路斯.png": 13155,
	"./assets/country/塞舌尔.png": 14315,
	"./assets/country/墨西哥.png": 35473,
	"./assets/country/多哥.png": 72466,
	"./assets/country/多米尼加.png": 64872,
	"./assets/country/奥地利.png": 87281,
	"./assets/country/委内瑞拉.png": 5647,
	"./assets/country/孟加拉国.png": 5318,
	"./assets/country/安哥拉.png": 59898,
	"./assets/country/安圭拉岛.png": 58715,
	"./assets/country/安提瓜和巴布达.png": 37227,
	"./assets/country/安道尔.png": 39973,
	"./assets/country/密克罗西亚联邦.png": 48092,
	"./assets/country/尼加拉瓜.png": 96742,
	"./assets/country/尼日利亚.png": 1393,
	"./assets/country/尼日尔.png": 47414,
	"./assets/country/尼泊尔.png": 35475,
	"./assets/country/巴勒斯坦.png": 90980,
	"./assets/country/巴哈马.png": 88565,
	"./assets/country/巴基斯坦.png": 91436,
	"./assets/country/巴巴多斯.png": 17608,
	"./assets/country/巴布亚新几内亚.png": 42799,
	"./assets/country/巴拉圭.png": 83723,
	"./assets/country/巴拿马.png": 2084,
	"./assets/country/巴林.png": 55850,
	"./assets/country/巴西.png": 65698,
	"./assets/country/布基纳法索.png": 1146,
	"./assets/country/布隆迪.png": 8090,
	"./assets/country/希腊.png": 36615,
	"./assets/country/库克群岛.png": 42896,
	"./assets/country/开曼群岛.png": 22394,
	"./assets/country/德国.png": 53301,
	"./assets/country/意大利.png": 39558,
	"./assets/country/所罗门群岛.png": 17795,
	"./assets/country/扎伊尔.png": 58937,
	"./assets/country/拉脱维亚.png": 20369,
	"./assets/country/挪威.png": 60134,
	"./assets/country/捷克.png": 11827,
	"./assets/country/摩尔多瓦.png": 39478,
	"./assets/country/摩洛哥.png": 68404,
	"./assets/country/摩纳哥.png": 25228,
	"./assets/country/文莱.png": 35449,
	"./assets/country/斐济.png": 68271,
	"./assets/country/斯威士兰.png": 86084,
	"./assets/country/斯洛伐克.png": 14056,
	"./assets/country/斯洛文尼亚.png": 3242,
	"./assets/country/斯里兰卡.png": 2357,
	"./assets/country/新加坡.png": 64380,
	"./assets/country/新西兰.png": 66756,
	"./assets/country/日本.png": 67926,
	"./assets/country/智利.png": 42910,
	"./assets/country/朝鲜.png": 64238,
	"./assets/country/柬埔寨.png": 98581,
	"./assets/country/格林纳达.png": 28741,
	"./assets/country/格鲁吉亚.png": 14213,
	"./assets/country/梵蒂冈.png": 76306,
	"./assets/country/比利时.png": 50728,
	"./assets/country/毛里塔尼亚.png": 78456,
	"./assets/country/毛里求斯.png": 87069,
	"./assets/country/汤加.png": 60741,
	"./assets/country/沙特阿拉伯.png": 23236,
	"./assets/country/法国.png": 57919,
	"./assets/country/法属圭亚那.png": 68902,
	"./assets/country/法属玻利尼西亚.png": 25185,
	"./assets/country/波兰.png": 60727,
	"./assets/country/波多黎各.png": 22595,
	"./assets/country/波斯尼亚.png": 49174,
	"./assets/country/泰国.png": 74948,
	"./assets/country/津巴布韦.png": 76433,
	"./assets/country/洪都拉斯.png": 48802,
	"./assets/country/海地.png": 54912,
	"./assets/country/澳大利亚.png": 8410,
	"./assets/country/爱尔兰.png": 96424,
	"./assets/country/爱沙尼亚.png": 98329,
	"./assets/country/牙买加.png": 35468,
	"./assets/country/特立尼达和多巴哥.png": 92680,
	"./assets/country/玻利维亚.png": 28267,
	"./assets/country/瑙鲁.png": 39031,
	"./assets/country/瑞典.png": 34923,
	"./assets/country/瑞士.png": 86720,
	"./assets/country/瓦努阿图.png": 86486,
	"./assets/country/留尼旺.png": 98482,
	"./assets/country/白俄罗斯.png": 91812,
	"./assets/country/百慕大群岛.png": 32300,
	"./assets/country/直布罗陀.png": 7179,
	"./assets/country/科威特.png": 60798,
	"./assets/country/科摩罗.png": 17176,
	"./assets/country/科特迪瓦.png": 92623,
	"./assets/country/秘鲁.png": 72064,
	"./assets/country/突尼斯.png": 7111,
	"./assets/country/立陶宛.png": 4587,
	"./assets/country/索马里.png": 10060,
	"./assets/country/约旦.png": 13853,
	"./assets/country/纳米比亚.png": 51185,
	"./assets/country/缅甸.png": 29986,
	"./assets/country/罗马尼亚.png": 21930,
	"./assets/country/美国.png": 14358,
	"./assets/country/老挝.png": 11891,
	"./assets/country/肯尼亚.png": 28916,
	"./assets/country/芬兰.png": 94493,
	"./assets/country/苏丹.png": 9593,
	"./assets/country/苏里南.png": 41553,
	"./assets/country/英国.png": 76739,
	"./assets/country/荷兰.png": 25600,
	"./assets/country/莫桑比克.png": 64538,
	"./assets/country/莱索托.png": 12070,
	"./assets/country/菲律宾.png": 36624,
	"./assets/country/萨尔瓦多.png": 93317,
	"./assets/country/葡萄牙.png": 67337,
	"./assets/country/蒙古.png": 12586,
	"./assets/country/蒙特塞拉特岛.png": 98988,
	"./assets/country/西撒哈拉.png": 18651,
	"./assets/country/西班牙.png": 97672,
	"./assets/country/西萨摩亚.png": 28369,
	"./assets/country/贝宁.png": 78171,
	"./assets/country/赞比亚.png": 3453,
	"./assets/country/赤道几内亚.png": 46409,
	"./assets/country/越南.png": 54880,
	"./assets/country/阿塞拜疆.png": 86556,
	"./assets/country/阿富汗.png": 39649,
	"./assets/country/阿尔及利亚.png": 83725,
	"./assets/country/阿尔巴尼亚.png": 8804,
	"./assets/country/阿曼.png": 548,
	"./assets/country/阿根廷.png": 30578,
	"./assets/country/阿森松.png": 53802,
	"./assets/country/阿联酋.png": 62853,
	"./assets/country/韩国.png": 16715,
	"./assets/country/马其顿.png": 80740,
	"./assets/country/马尔代夫.png": 72727,
	"./assets/country/马拉维.png": 56242,
	"./assets/country/马来西亚.png": 24203,
	"./assets/country/马耳他.png": 50146,
	"./assets/country/马达加斯加.png": 50014,
	"./assets/country/马里.png": 86897,
	"./assets/country/黎巴嫩.png": 93958,
	"./assets/download/android_logo.png": 94432,
	"./assets/download/apple_logo.png": 9131,
	"./assets/download/code-container.png": 60960,
	"./assets/download/code.png": 31938,
	"./assets/download/downloadBgi.png": 58259,
	"./assets/download/google_logo.png": 71136,
	"./assets/footer/android_logo.png": 61083,
	"./assets/footer/apple_logo.png": 35140,
	"./assets/footer/download_logo.png": 47694,
	"./assets/footer/google_logo.png": 29905,
	"./assets/futures/add.png": 15350,
	"./assets/futures/cal.png": 68971,
	"./assets/futures/cal_new.png": 65664,
	"./assets/futures/cancel_all.png": 42753,
	"./assets/futures/edit_margin.png": 56114,
	"./assets/futures/empty_g.png": 37546,
	"./assets/futures/empty_y.png": 42084,
	"./assets/futures/error.png": 78941,
	"./assets/futures/expand.png": 12119,
	"./assets/futures/fold.png": 44562,
	"./assets/futures/logo.png": 23530,
	"./assets/futures/margin_g.png": 24811,
	"./assets/futures/margin_y.png": 32469,
	"./assets/futures/more_g.png": 73706,
	"./assets/futures/more_y.png": 78244,
	"./assets/futures/order_logo.png": 36881,
	"./assets/futures/price-instructions.png": 66980,
	"./assets/futures/set_icon.png": 83863,
	"./assets/futures/share_1.png": 47722,
	"./assets/futures/share_2.png": 96705,
	"./assets/futures/sub.png": 80969,
	"./assets/futures/title_logo_g.png": 30193,
	"./assets/futures/title_logo_r.png": 62684,
	"./assets/futures/trans_logo.png": 28751,
	"./assets/help/E-Banking.png": 73808,
	"./assets/help/help-serve.png": 93001,
	"./assets/help/help_banner.png": 45134,
	"./assets/help/problem_icon_1.png": 15857,
	"./assets/help/problem_icon_2.png": 11098,
	"./assets/help/problem_icon_3.png": 58851,
	"./assets/help/problem_icon_4.png": 98956,
	"./assets/help/problem_icon_5.png": 34869,
	"./assets/help/problem_icon_6.png": 49118,
	"./assets/help/search.png": 29394,
	"./assets/help/serve_icon_1.png": 18217,
	"./assets/help/serve_icon_2.png": 70034,
	"./assets/help/serve_icon_3.png": 91579,
	"./assets/help/serve_icon_4.png": 36772,
	"./assets/help/serve_icon_5.png": 13,
	"./assets/help/serve_icon_6.png": 68246,
	"./assets/help/serve_icon_7.png": 22047,
	"./assets/help/serve_icon_8.png": 74984,
	"./assets/home/android_apk.png": 27650,
	"./assets/home/api_key.png": 89484,
	"./assets/home/app_store.png": 1363,
	"./assets/home/asset_g.png": 36062,
	"./assets/home/asset_h.png": 91817,
	"./assets/home/asset_white.png": 16622,
	"./assets/home/assets_account_g.png": 25663,
	"./assets/home/assets_account_y.png": 15457,
	"./assets/home/avatar.png": 85921,
	"./assets/home/c2c_g.png": 78528,
	"./assets/home/c2c_y.png": 67182,
	"./assets/home/contract_g.png": 3926,
	"./assets/home/contract_y.png": 57016,
	"./assets/home/crowdfund-detail-user-icon.png": 36960,
	"./assets/home/deal_g.png": 48681,
	"./assets/home/deal_y.png": 65240,
	"./assets/home/down_logo.png": 69482,
	"./assets/home/download_y.png": 6566,
	"./assets/home/finance-product-bg.png": 89190,
	"./assets/home/finance-v-icon.png": 56781,
	"./assets/home/finance_banner_1.png": 58301,
	"./assets/home/google_pay.png": 55496,
	"./assets/home/home_bg.png": 43365,
	"./assets/home/home_bg1.png": 84376,
	"./assets/home/icon1.png": 78212,
	"./assets/home/icon2.png": 15071,
	"./assets/home/icon3.png": 1782,
	"./assets/home/institution-icon.png": 28262,
	"./assets/home/invite_g.png": 96859,
	"./assets/home/invite_h.png": 92844,
	"./assets/home/left_img.png": 44725,
	"./assets/home/login.png": 25951,
	"./assets/home/logout_g.png": 95582,
	"./assets/home/logout_h.png": 41449,
	"./assets/home/message_icon.png": 11813,
	"./assets/home/message_icon_y.png": 86757,
	"./assets/home/not_approve.png": 80861,
	"./assets/home/options_g.png": 86376,
	"./assets/home/options_y.png": 18630,
	"./assets/home/overview_g.png": 67761,
	"./assets/home/overview_y.png": 34319,
	"./assets/home/page_white.png": 37021,
	"./assets/home/quotes_white.png": 18415,
	"./assets/home/register.png": 5965,
	"./assets/home/right_img.png": 19322,
	"./assets/home/role-change-icon.png": 5151,
	"./assets/home/s_icon1_b.png": 84593,
	"./assets/home/s_icon1_h.png": 31227,
	"./assets/home/s_icon2_b.png": 68790,
	"./assets/home/s_icon2_h.png": 88108,
	"./assets/home/s_icon3_b.png": 51159,
	"./assets/home/s_icon3_h.png": 85661,
	"./assets/home/s_icon4_b.png": 82740,
	"./assets/home/s_icon4_h.png": 66318,
	"./assets/home/s_icon5_b.png": 60757,
	"./assets/home/s_icon5_h.png": 2463,
	"./assets/home/s_icon6_b.png": 62634,
	"./assets/home/s_icon6_h.png": 88368,
	"./assets/home/s_icon7_b.png": 21163,
	"./assets/home/s_icon7_h.png": 11297,
	"./assets/home/safe_g.png": 91435,
	"./assets/home/safe_h.png": 87836,
	"./assets/home/social_bg.png": 1033,
	"./assets/home/spot_account_g.png": 2164,
	"./assets/home/spot_account_y.png": 91322,
	"./assets/home/spot_g.png": 80108,
	"./assets/home/spot_y.png": 10914,
	"./assets/home/success-result-icon.png": 81557,
	"./assets/home/tg_b.png": 38478,
	"./assets/home/tg_h.png": 11700,
	"./assets/home/tw_b.png": 17438,
	"./assets/home/tw_h.png": 71844,
	"./assets/home/up_logo.png": 4123,
	"./assets/home/user_icon.png": 35687,
	"./assets/home/user_icon_y.png": 38771,
	"./assets/home/user_logo.png": 31833,
	"./assets/home/verify_g.png": 81995,
	"./assets/home/verify_h.png": 1692,
	"./assets/home/yes_approve.png": 42287,
	"./assets/login/login-bgi.png": 21298,
	"./assets/login/login_l.png": 58706,
	"./assets/login/login_r.png": 77212,
	"./assets/login/register-img.png": 12227,
	"./assets/login/success.png": 53505,
	"./assets/quotes/collect_g.png": 62078,
	"./assets/quotes/collect_y.png": 68880,
	"./assets/spotTrading/arrow_down.png": 12684,
	"./assets/spotTrading/buy.png": 51872,
	"./assets/spotTrading/buy_checked.png": 88946,
	"./assets/spotTrading/buy_d.png": 54069,
	"./assets/spotTrading/buy_g.png": 33694,
	"./assets/spotTrading/checked.png": 96703,
	"./assets/spotTrading/download.png": 67094,
	"./assets/spotTrading/full_screen.png": 21886,
	"./assets/spotTrading/sale.png": 14891,
	"./assets/spotTrading/sale_checked.png": 51761,
	"./assets/spotTrading/search.png": 426,
	"./assets/spotTrading/sell_d.png": 19111,
	"./assets/spotTrading/sell_r.png": 39297,
	"./assets/spotTrading/shape.png": 40687,
	"./assets/spotTrading/shape_1_checked.png": 84025,
	"./assets/spotTrading/shape_1_nocheck .png": 78841,
	"./assets/spotTrading/shape_2_checked.png": 90538,
	"./assets/spotTrading/shape_2_nocheck .png": 4976,
	"./assets/spotTrading/shape_3_checked.png": 25671,
	"./assets/spotTrading/shape_3_nocheck .png": 1235,
	"./assets/spotTrading/shape_4_checked.png": 64736,
	"./assets/spotTrading/shape_4_nocheck .png": 72826,
	"./assets/spotTrading/shape_5_checked.png": 47149,
	"./assets/spotTrading/shape_5_nocheck .png": 43349,
	"./assets/spotTrading/shape_6_checked.png": 28254,
	"./assets/spotTrading/shape_6_nocheck .png": 89740,
	"./assets/spotTrading/shape_7_checked.png": 9611,
	"./assets/spotTrading/shape_7_nocheck .png": 31551,
	"./assets/spotTrading/snapshot.png": 48338,
	"./assets/spotTrading/split_screen.png": 55657,
	"./assets/spotTrading/study.png": 62671,
	"./assets/spotTrading/study_img.png": 3195,
	"./assets/spotTrading/time_checked.png": 55363,
	"./assets/spotTrading/time_nochecked.png": 17172,
	"./assets/spotTrading/total.png": 33906,
	"./assets/spotTrading/total_checked.png": 39908,
	"./assets/spotTrading/triangle_checked_down.png": 23597,
	"./assets/spotTrading/triangle_checked_top.png": 44884,
	"./assets/spotTrading/triangle_nocheck_down.png": 21061,
	"./assets/spotTrading/triangle_nocheck_top.png": 97215,
	"./assets/spotTrading/twitter.png": 77721,
	"./assets/station/active_g.png": 16547,
	"./assets/station/active_y.png": 44733,
	"./assets/station/all_g.png": 13104,
	"./assets/station/all_y.png": 57886,
	"./assets/station/system_g.png": 41446,
	"./assets/station/system_y.png": 69512,
	"./assets/transfer/coin.png": 61765,
	"./assets/transfer/operation.png": 78439,
	"./assets/transfer/success.png": 46173,
	"./assets/transfer/tip.png": 54323,
	"./assets/user/add_avatar.png": 9301,
	"./assets/user/agree.png": 74884,
	"./assets/user/andorra.png": 62403,
	"./assets/user/apple.png": 84072,
	"./assets/user/arrow.png": 69091,
	"./assets/user/avatar.png": 10482,
	"./assets/user/bg.png": 59735,
	"./assets/user/china.png": 15629,
	"./assets/user/computer.png": 19853,
	"./assets/user/confirm.png": 82300,
	"./assets/user/download_icon.png": 80128,
	"./assets/user/email.png": 37040,
	"./assets/user/error_icon.png": 64788,
	"./assets/user/eye_close.png": 32294,
	"./assets/user/eye_open.png": 88372,
	"./assets/user/eye_show.png": 19947,
	"./assets/user/google.png": 88151,
	"./assets/user/icon1.png": 46480,
	"./assets/user/icon2.png": 11883,
	"./assets/user/nickname.png": 94042,
	"./assets/user/no_agree.png": 24394,
	"./assets/user/no_logo.png": 5765,
	"./assets/user/no_show.png": 75279,
	"./assets/user/pass.png": 58193,
	"./assets/user/password.png": 8645,
	"./assets/user/phone.png": 54016,
	"./assets/user/qrcode_icon.png": 78846,
	"./assets/user/right.png": 10822,
	"./assets/user/safe_factor_0.png": 9970,
	"./assets/user/safe_factor_1.png": 24795,
	"./assets/user/safe_factor_2.png": 46464,
	"./assets/user/safe_factor_3.png": 24585,
	"./assets/user/safe_factor_4.png": 84502,
	"./assets/user/safety_bg.png": 67624,
	"./assets/user/slider.png": 1685,
	"./assets/user/slider_black.png": 30657,
	"./assets/user/slider_btn.png": 78287,
	"./assets/user/success_icon.png": 78245,
	"./assets/user/tips_icon.png": 6770,
	"./assets/user/tips_icon_big.png": 64997,
	"./assets/user/tips_icon_g.png": 51680,
	"./assets/user/tips_logo.png": 80496,
	"./assets/user/union.png": 95301,
	"./assets/user/vector.png": 72467,
	"./assets/user/verify_logo.png": 4271,
	"./assets/user/warn_logo.png": 47858,
	"./assets/user/wrong.png": 41623,
	"./assets/user/yes_logo.png": 78623,
	"./assets/withdraw/E-Banking.png": 75151,
	"./assets/withdraw/EMT.png": 52805,
	"./assets/withdraw/Wise.png": 28615,
	"./assets/withdraw/cash-out-before-mode-1.png": 81675,
	"./assets/withdraw/cash-out-before-mode-2.png": 10384,
	"./assets/withdraw/headset.png": 65537,
	"./assets/withdraw/more-result-copy.png": 36144,
	"./assets/withdraw/upload.png": 72964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15353;